<template>
  <v-dialog v-model="openDialog" :max-width="hideOfferSales ? '800px' : '1200px'" persistent scrollable>
    <template v-slot:activator="{ on }">
      <div v-on="disabled ? null : on">
        <mf-button
          v-if="onlyOfferSales"
          outlined
          :badge-content="selectedCampaign.length"
          label="Selecionar ofertas"
          icon="attach_money"
          iconPosition="left"
          fill-icon
          :disabled="disabled"
          :height="40"
          text-transform="none"
        />
        <mf-button
          v-else-if="type === 'button'"
          outlined
          :badge-content="selectedCampaign.length"
          label="Campanha"
          icon="lightbulb"
          iconPosition="left"
          fill-icon
          :disabled="disabled"
          :height="40"
          text-transform="none"
        />
        <mf-search v-else id="campaign-label" placeholder="Selecione a campanha" hide-details :value="textFieldValue" />
      </div>
    </template>
    <v-card>
      <v-card-title>
        <span class="mf-h6 primary-text">Selecionar campanhas</span>
      </v-card-title>

      <v-card-text v-if="onlyOfferSales">
        <select-campaigns-offer-sales v-model="campaigns" :status="status" :single-checkbox="singleCheckbox" :hide-industry="hideIndustry" />
      </v-card-text>

      <v-card-text v-else-if="!hideOfferSales" class="px-0">
        <mf-tabs-menu v-model="templateTab" :tabs="tabsMenuItems" class="my-4" />
        <v-container class="mx-0" fluid>
          <select-campaigns-table-tab
            v-show="templateTab === 0"
            v-model="campaigns"
            :mode="mode"
            :include-maria-campaign="includeMariaCampaign"
            :status="status"
            :single-checkbox="singleCheckbox"
            :use-campaign-frequency="useCampaignFrequency"
          />
          <select-campaigns-offer-sales
            v-show="templateTab === 1"
            v-model="campaigns"
            :status="status"
            :single-checkbox="singleCheckbox"
            :hide-industry="hideIndustry"
          />
        </v-container>
      </v-card-text>

      <v-card-text v-else class="px-0">
        <v-container class="mx-0" fluid>
          <select-campaigns-table-tab
            v-show="templateTab === 0"
            v-model="campaigns"
            :single-checkbox="singleCheckbox"
            :mode="mode"
            :include-maria-campaign="includeMariaCampaign"
            :status="status"
            :use-campaign-frequency="useCampaignFrequency"
          />
        </v-container>
      </v-card-text>
      <mf-action-buttons
        class="pa-2"
        :primary-button="{
          text: 'Confirmar',
          action: selectCampaign,
          isVisible: true,
        }"
        :extra-button="{
          text: 'Cancelar',
          action: closeDialog,
          isVisible: true,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import SelectCampaignsTableTab from './SelectCampaignsTableTab.vue'
import SelectCampaignsOfferSales from './SelectCampaignsOfferSales.vue'
import { QUERY_GET_GENERIC_CAMPAIGNS_PRODUCTS_BY_ID } from './graphql'

export default {
  name: 'SelectCampaignsModal',
  components: {
    SelectCampaignsTableTab,
    SelectCampaignsOfferSales,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    includeMariaCampaign: {
      type: Boolean,
      default: false,
    },
    getProducts: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: Array,
      required: true,
    },
    hideOfferSales: {
      type: Boolean,
      default: false,
    },
    singleCheckbox: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Array,
      default: () => ['ACTIVE', 'FINISHED'],
    },
    useCampaignFrequency: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'search',
    },
    onlyOfferSales: {
      type: Boolean,
      default: false,
    },
    hideIndustry: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    openDialog: false,
    templateTab: 0,
    campaigns: [],
  }),
  computed: {
    tabsMenuItems() {
      return [
        {
          name: 'Campanhas',
          offerSalesKeyName: 'campaigns',
        },
        {
          name: 'Gestão de ofertas',
          offerSalesKeyName: 'offerSales',
        },
      ]
    },
    textFieldValue() {
      if (!this.selectedCampaign.length) return 'Escolher campanhas'
      if (!this.singleCheckbox) return this.selectedCampaign.length === 1 ? '1 selecionada' : `${this.selectedCampaign.length} selecionadas`
      return this.selectedCampaign
        .map((campaign) => {
          return campaign.hasOwnProperty('title') ? campaign.title : campaign.name
        })
        .join(', ')
    },
    selectedCampaign: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  mounted() {
    if (this.value) this.campaigns = this.value
  },
  methods: {
    closeDialog() {
      this.openDialog = false
    },
    selectCampaign() {
      if (this.templateTab === 0 && this.getProducts && !this.onlyOfferSales) {
        this.getCampaignProducts()
      } else if ((this.templateTab === 1 || this.onlyOfferSales) && this.getProducts) {
        this.getOfferSalesProducts()
      } else {
        this.selectedCampaign = this.campaigns
      }
      this.closeDialog()
    },
    getCampaignProducts() {
      const { _id } = this.campaigns[0]
      this.$apollo
        .query({
          query: QUERY_GET_GENERIC_CAMPAIGNS_PRODUCTS_BY_ID,
          variables: { _id },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { genericCampaign } }) => {
          const newCampaign = this.campaigns[0]

          if (genericCampaign.products) {
            newCampaign.products = genericCampaign.products
          }

          this.selectedCampaign = [newCampaign]
        })
    },
    getOfferSalesProducts() {
      this.selectedCampaign = this.campaigns.map((campaign) => {
        return {
          ...campaign,
          products: this.getAllOfferSalesProducts(campaign),
        }
      })
    },
    getAllOfferSalesProducts(offer) {
      const productsArray = [
        'offer_sales',
        'percentage_offer_sales',
        'dynamic_pricing_percentage',
        'dynamic_pricing_percentage_offer_sales',
        'takepay_offer_sales',
        'combo_offer_sales',
        'cashback_percentage_offer_sales',
        'cashback_absolute_offer_sales',
        'points_offer_sales',
        'next_buy_cashback_offer_sales',
        'dynamic_rule_offer_sales',
        'cross_sell_offer_sales',
      ].reduce((accumulator, current) => {
        if (offer[current] && offer[current].length && current !== 'combo_offer_sales') {
          const products = offer[current].reduce((productsArray, currentProduct) => {
            if (currentProduct[current] && currentProduct[current].length) {
              const groupProducts = currentProduct[current].map((item) => ({
                ...item,
                _id: item?.product?._id,
              }))
              return productsArray.concat(groupProducts)
            } else {
              productsArray.push({ ...currentProduct, _id: currentProduct?.product?._id })
            }
            return productsArray
          }, [])

          accumulator.push(...products)
        } else if (offer[current] && offer[current].length && current === 'combo_offer_sales') {
          const comboProducts = this.getOfferComboProducts(offer[current]).map((item) => ({ ...item, _id: item?.product?._id }))
          accumulator.push(...comboProducts)
        }
        return accumulator
      }, [])
      return productsArray
    },

    getOfferComboProducts(comboOffers) {
      const products = comboOffers.reduce((productOfferArray, comboOffer) => {
        const { trigger_products, target_products } = comboOffer

        const newProducts = trigger_products.reduce((productsArray, currentProduct) => {
          if (currentProduct.trigger_products && currentProduct.trigger_products.length) {
            productsArray.push(...currentProduct.trigger_products)
          } else {
            productsArray.push(currentProduct)
          }

          return productsArray
        }, [])

        if (newProducts.length > 0) {
          productOfferArray.push(...newProducts)
        }

        if (target_products && target_products.length) {
          productOfferArray.push(...target_products)
        }

        return productOfferArray
      }, [])

      return products
    },

    clearCampaigns() {
      this.campaigns = []
    },
  },
}
</script>

<style lang="scss">
.button-import {
  .theme--light.v-btn {
    color: $marca-0-l40 !important;
  }
  .v-btn.v-size--default {
    font-size: 14px !important;
  }
}
.text-size {
  font-size: 16px !important;
}
</style>
